import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import ReactDOM from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';
import i18next from 'i18next';

const printQRCode = (item, itemType, t) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`<html><head><title>${t(StringKeys.PRINT_QR_CODE)}</title>`);
    printWindow.document.write('<style>');
    printWindow.document.write(`
        @media print { 
            body {
                margin: 0;
                padding: 0;
            }
            .print-only { 
                display: block;
            }
            .page-container {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 8.5in;
                padding: 0.25in;
                box-sizing: border-box;
            }
            .qr-container { 
                display: inline-block;
                margin: 0.1in;
                padding: 0.1in;
                border: 1px solid #ccc;
                text-align: center;
                width: 2.5in;
                height: 3.8in;
                vertical-align: top;
                box-sizing: border-box;
            }
            .image-container {
                width: 0.8in;
                height: 0.8in;
                margin: 0.1in auto;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .image-container img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
            @page {
                size: letter landscape;
                margin: 0;
            }
            h4 {
                margin: 0.1in 0;
                min-height: 0.3in;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12pt;
            }
            p {
                margin: 0.05in 0;
                font-size: 10pt;
            }
            .qr-code-container {
                margin: 0.1in 0;
            }
            .qr-code-container svg {
                width: 1.2in;
                height: 1.2in;
            }
        }
    `);
    printWindow.document.write('</style></head><body><div class="page-container">');
    
    const itemUrl = window.location.href;
    printWindow.document.write(`
        <div class="qr-container">
            <h4>${item.name}</h4>
            ${itemType === 'inventory' ? `
                <p>${t(StringKeys.MINIMUM_QUANTITY)}: ${item.minimum_quantity}</p>
                <p>${t(StringKeys.REORDER_QUANTITY)}: ${item.reorder_quantity}</p>
            ` : `
                <p>${t(StringKeys.SERIAL_NUMBER)}: ${item.serial_number}</p>
                <p>${t(StringKeys.CONDITION)}: ${t(item.condition)}</p>
            `}
            <div class="image-container">
                ${item.image_url 
                    ? `<img src="${item.image_url}" alt="Item Image" />` 
                    : `<svg width="100%" height="100%" viewBox="0 0 100 100">
                        <rect width="100" height="100" fill="#f0f0f0"/>
                        <text x="50" y="50" font-family="Arial" font-size="12" fill="#666" text-anchor="middle" dominant-baseline="middle">No Image</text>
                       </svg>`
                }
            </div>
            <div class="qr-code-container" id="qr-code"></div>
        </div>
    `);
    
    printWindow.document.write('</div></body></html>');
    printWindow.document.close();

    const tempContainer = document.createElement('div');
    tempContainer.style.display = 'none';
    document.body.appendChild(tempContainer);

    const qrCodeContainer = document.createElement('div');
    qrCodeContainer.id = 'temp-qr';
    tempContainer.appendChild(qrCodeContainer);

    const root = ReactDOM.createRoot(qrCodeContainer);
    root.render(<QRCodeSVG value={itemUrl} size={128} />);

    setTimeout(() => {
        const svg = qrCodeContainer.querySelector('svg');
        if (svg) {
            const qrContainer = printWindow.document.getElementById('qr-code');
            qrContainer.appendChild(svg.cloneNode(true));
        }
        
        setTimeout(() => {
            printWindow.print();
            document.body.removeChild(tempContainer);
        }, 500);
    }, 0);
};

const printMultipleQRCodes = (items, itemType, t) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`<html><head><title>${t(StringKeys.PRINT_QR_CODE)}</title>`);
    printWindow.document.write('<style>');
    printWindow.document.write(`
        @media print { 
            body {
                margin: 0;
                padding: 0;
            }
            .print-only { 
                display: block;
            }
            .page-container {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-content: center;
                padding: 0.25in;
                box-sizing: border-box;
                min-height: 8.5in;
            }
            .qr-container { 
                display: inline-block;
                margin: 0.1in;
                padding: 0.1in;
                border: 1px solid #ccc;
                text-align: center;
                width: 2.5in;
                height: 3.8in;
                vertical-align: top;
                box-sizing: border-box;
            }
            .image-container {
                width: 0.8in;
                height: 0.8in;
                margin: 0.1in auto;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .image-container img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
            .page-break { 
                page-break-after: always; 
                break-after: page;
                clear: both;
            }
            @page {
                size: letter landscape;
                margin: 0;
            }
            h4 {
                margin: 0.1in 0;
                min-height: 0.3in;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12pt;
            }
            p {
                margin: 0.05in 0;
                font-size: 10pt;
            }
            .qr-code-container {
                margin: 0.1in 0;
            }
            .qr-code-container svg {
                width: 1.2in;
                height: 1.2in;
            }
        }
    `);
    printWindow.document.write('</style></head><body><div class="page-container">');
    
    items.forEach((item, index) => {
        const itemUrl = `${window.location.origin}/${itemType}/${item.id}`;
        printWindow.document.write(`
            <div class="qr-container">
                <h4>${item.name}</h4>
                ${itemType === 'inventory' ? `
                    <p>${t(StringKeys.MINIMUM_QUANTITY)}: ${item.minimum_quantity}</p>
                    <p>${t(StringKeys.REORDER_QUANTITY)}: ${item.reorder_quantity}</p>
                ` : `
                    <p>${t(StringKeys.SERIAL_NUMBER)}: ${item.serial_number}</p>
                    <p>${t(StringKeys.CONDITION)}: ${t(item.condition)}</p>
                `}
                <div class="image-container">
                    ${item.image_url 
                        ? `<img src="${item.image_url}" alt="Item Image" />` 
                        : `<svg width="100%" height="100%" viewBox="0 0 100 100">
                            <rect width="100" height="100" fill="#f0f0f0"/>
                            <text x="50" y="50" font-family="Arial" font-size="12" fill="#666" text-anchor="middle" dominant-baseline="middle">No Image</text>
                           </svg>`
                    }
                </div>
                <div class="qr-code-container" id="qr-code-${item.id}"></div>
            </div>
            ${(index + 1) % 8 === 0 ? '</div><div class="page-break"></div><div class="page-container">' : ''}
        `);
    });
    
    printWindow.document.write('</div></body></html>');
    printWindow.document.close();

    const tempContainer = document.createElement('div');
    tempContainer.style.display = 'none';
    document.body.appendChild(tempContainer);

    items.forEach(item => {
        const itemUrl = `${window.location.origin}/${itemType}/${item.id}`;
        const qrContainer = printWindow.document.getElementById(`qr-code-${item.id}`);
        
        qrContainer.innerHTML = '';
        
        const qrCodeContainer = document.createElement('div');
        qrCodeContainer.id = `temp-qr-${item.id}`;
        tempContainer.appendChild(qrCodeContainer);

        const root = ReactDOM.createRoot(qrCodeContainer);
        root.render(<QRCodeSVG value={itemUrl} size={128} />);

        setTimeout(() => {
            const svg = qrCodeContainer.querySelector('svg');
            if (svg) {
                qrContainer.appendChild(svg.cloneNode(true));
            }
        }, 0);
    });

    setTimeout(() => {
        printWindow.print();
        document.body.removeChild(tempContainer);
    }, 500);
};

const useQRCodePrinter = () => {
    const { t } = useTranslation();

    return {
        printQRCode: (item, itemType) => printQRCode(item, itemType, t),
        printMultipleQRCodes: (items, itemType) => printMultipleQRCodes(items, itemType, t)
    };
};

export { useQRCodePrinter }; 